import { all, put, select, takeEvery } from "redux-saga/effects";

import { GET_BILLING_RULES_SETTINGS_CHANGES } from "constants/actionTypes";
import { actionFilters, ruleActionTypes } from "lib/actionFilters";

export function* fetchBillingRulesSettings() {
  const state = yield select();

  // Get all the billing rules
  yield all(
    ruleActionTypes
      .map(actionSet => actionFilters[actionSet.dataType](state, false))
      .filter(Boolean)
      .map(action => put(action)),
  );
}

export default function* settingsSaga() {
  yield takeEvery(
    GET_BILLING_RULES_SETTINGS_CHANGES,
    fetchBillingRulesSettings,
  );
}
